import React, { useState, useEffect, useContext } from "react";
import {
  Typography,
  Grid,
  CircularProgress,
  Card,
  List,
  ListItem,
} from "@material-ui/core";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../Context/Langcontext";
import Tooltips from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  maintext: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#595A5A",
  },
  gridend: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
  },
  showbar: {
    height: 360,
    // width: "100%",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      minWidth: "50%",
      maxWidth: "80%",
    },
  },
  cardtooltip: {
    margin: "1rem",
    display: "flex",
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    zIndex: 99999,
    backgroundColor: "#ffffff87",
    borderRadius: 8,
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
  },
  fonttooltip: {
    fontSize: "0.7rem",
    fontWeight: 400,
    color: "#E16733",
  },
  fontlabel: {
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#595A5A",
  },
}));

const Barcharincome = ({ data }) => {
  const classes = useStyles();
  const [loading, setloading] = useState(false);
  const [fetch, setfetch] = useState(false);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  useEffect(() => {
    if (!fetch) {
      setloading(true);
      setTimeout(() => {
        setloading(false);
      }, 1500);
      setfetch(true);
    } else {
    }
  }, [fetch]);

  const getAllBatg = () => {
    let all = 0;
    data.map((rs) => {
      return (all = Number(Number(all) + Number(rs.income)));
    });

    return all;
  };

  const renderTooltip = (props) => {
    let { payload } = props;
    if (props.active) {
      return (
        <Card className={classes.cardtooltip}>
          <List>
            {payload.map((entry, index) => {
              return (
                <ListItem key={`${entry.dataKey}_${index}`}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography className={classes.fontlabel}>
                        {entry.payload.name}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <Typography className={classes.fonttooltip}>
                        {`${lang.Income} : ${entry.value.toLocaleString()} ${
                          lang.THB
                        }`}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        </Card>
      );
    } else {
      return null;
    }
  };

  const NoData = [{ name: lang.NotFound, usage: 0 }];
  return (
    <div style={{ margin: "2rem" }}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Tooltips title="กราฟแสดงรายรับ" placement="top-start">
            <Typography className={classes.maintext}>{lang.Income}</Typography>
          </Tooltips>
        </Grid>
        <Grid item xs={6} className={classes.gridend}>
          <Tooltips title="จำนวนรายรับ" placement="top">
            <Typography className={classes.maintext}>
              {getAllBatg().toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
              {" "+lang.Bath}
            </Typography>
          </Tooltips>
        </Grid>
        <Grid
          item
          md={12}
          sm={12}
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          {loading ? (
            <CircularProgress />
          ) : (
            <div className={classes.showbar}>
              <ResponsiveContainer width="99%">
                <BarChart
                  // width={500}
                  // height={300}
                  data={data.length ? data : NoData}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                  barSize={40}
                >
                  <CartesianGrid strokeLinecap="round" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip content={renderTooltip} />
                  <Bar dataKey="income" fill="#E16733" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default Barcharincome;
